import { render, staticRenderFns } from "./message-visitor.vue?vue&type=template&id=ce3cc572&scoped=true&"
import script from "./message-visitor.vue?vue&type=script&lang=ts&"
export * from "./message-visitor.vue?vue&type=script&lang=ts&"
import style0 from "./message-visitor.vue?vue&type=style&index=0&id=ce3cc572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3cc572",
  null
  
)

export default component.exports